var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.productList && _vm.productList.length > 0 && _vm.productList[0])?_c('div',{staticClass:"product-chip-wrapper"},_vm._l((_vm.productList),function(item){return _c('div',{key:item,staticClass:"product-chip"},[_vm._v(_vm._s(item))])}),0):_c('input',{staticClass:"form-control search",attrs:{"disabled":"","type":"text"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }